import type {
  TripContext,
  WatchAlertView,
} from "@b2bportal/air-price-watch-api";
import { useAirPriceWatchStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreAirPriceWatchComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useWatchActions } from "@tenant/air-price-watch";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import { CancelWatchModalContent } from "../CancelWatchModalContent";
import { ChangeWatchEmailModalContent } from "../ChangeWatchEmailModalContent";
import defaultStyles from "./WatchActions.module.scss";

export interface WatchActionsComponentProps {
  watch: WatchAlertView;
  tripContext: TripContext;
  refetch: () => void;
}

const COMPONENT_KEY = CoreAirPriceWatchComponent.WatchActions;

export const WatchActions = (props: WatchActionsComponentProps) => {
  const styles = useAirPriceWatchStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();
  const {
    context: { changeOpen, cancelOpen },
    handlers: { setChangeOpen, setCancelOpen, onBookNow },
  } = useWatchActions(props);

  return (
    <div className={clsx(block)}>
      <Dialog
        open={changeOpen}
        onOpen={() => setChangeOpen(true)}
        onClose={() => setChangeOpen(false)}
      >
        <DialogTrigger>
          <span className={cn("watch-action")}>
            {t("watch.flightWatchChangeEmailButtonLabel")}
          </span>
        </DialogTrigger>
        <DialogContent title={t("watch.flightWatchChangeEmailButtonLabel")}>
          <ChangeWatchEmailModalContent
            watch={props.watch}
            tripContext={props.tripContext}
            onClose={() => setChangeOpen(false)}
            refetch={props.refetch}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={cancelOpen}
        onOpen={() => setCancelOpen(true)}
        onClose={() => setCancelOpen(false)}
      >
        <DialogTrigger title={t("watch.flightWatchStopWatchingButtonLabel")}>
          <span className={cn("watch-action")}>
            {t("watch.stopWatchButtonLabel")}
          </span>
        </DialogTrigger>
        <DialogContent title={t("watch.flightWatchStopWatchingButtonLabel")}>
          <CancelWatchModalContent
            watch={props.watch}
            tripContext={props.tripContext}
            onClose={() => setCancelOpen(false)}
            refetch={props.refetch}
          />
        </DialogContent>
      </Dialog>

      <button className={cn("watch-action")} onClick={onBookNow}>
        {t("watch.bookNowCTA")}
      </button>
    </div>
  );
};
